class ProductGrid extends HTMLElement {
  constructor() {
    super();
    this.viewMoreButton = document.getElementById('view-more-button');
    this.viewMoreStatus = document.querySelector('[data-view-more-status]');
    this.events = {
      success: 'viewmore_loaded',
    };

    if (!this.viewMoreButton) return;

    this.maxCount = parseInt(this.viewMoreButton.dataset.viewMoreMax, 10);
    this.countPerPage = parseInt(this.viewMoreButton.dataset.viewMoreStep, 10);
    this.currentCount = parseInt(
      this.viewMoreButton.dataset.viewMoreCurrent,
      10
    );
    this.isLoading = false;
    this._setupEventHandlers();
  }
  
  _getEventHandlers() {
    return {
      onClickViewMoreHandler: this._loadItems.bind(this),
    };
  }

  _setupEventHandlers() {
    this.eventHandlers = this._getEventHandlers();
    this.viewMoreButton.addEventListener(
      'click',
      this.eventHandlers.onClickViewMoreHandler
    );
  }

  _getNextPage() {
    const nextPage = Math.floor(this.currentCount / this.countPerPage) + 1;
    const url = this.viewMoreButton.dataset.viewMoreNext.replace(
      '[pagination]',
      nextPage
    );
    return url;
  }

  _fireEvent(eventName, data) {
    this.dispatchEvent(
      new window.CustomEvent(eventName, {
        detail: data,
      })
    );
  }

  _loadItems() {
    if (this.isLoading || this.currentCount >= this.maxCount) return;
    const url = this._getNextPage();
    this.isLoading = true;
    this._toggleLoadingState(true)
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        return parser.parseFromString(text, 'text/html');
      })
      .then((html) => {
        const items = [...html.querySelectorAll('.product-grid li')];
        if (this.currentCount < this.countPerPage) {
          items.splice(0, this.currentCount);
        }

        this.isLoading = false;
        this._toggleLoadingState(false)
        this.currentCount += items.length;
        this._updateButton();
        this._updateLiveRegion();
        this._updateProducts(items);
        this._fireEvent(this.events.success, { items });
      })
      .catch((error) => {
        this.isLoading = false;
        throw new Error(error);
      });
  }

  _toggleLoadingState(shouldDisableButton) {
    this.querySelector("#view-more-button .loading-overlay__spinner").classList.toggle('hidden');
    const loadMoreButton = this.querySelector("#view-more-button");
    loadMoreButton.setAttribute('aria-disabled', shouldDisableButton);
    loadMoreButton.classList.toggle('loading');
  }

  _updateProducts(items) {
    this.currentList = document.getElementById("product-grid");

    items.forEach((item, index) => {
      const insertedProduct = this.currentList.appendChild(item);
      if (index === 0) {
        if (insertedProduct.querySelector('.card--media .card__heading.h5 a')) {
          insertedProduct.querySelector('.card--media .card__heading.h5 a').focus()
        } else {
          insertedProduct.querySelector('.card--text .card__heading a').focus()
        }
      }
    });
  }

  _updateButton() {
    this.viewMoreButton.dataset.viewMoreCurrent = this.currentCount;

    if (this.currentCount >= this.maxCount) {
      this.viewMoreButton.classList.add('hidden');
    }
  }

  _updateLiveRegion() {
    const viewMoreStatusMessage = this.viewMoreStatus.dataset.viewMoreStatusMessage
      .replace('[item_count]', this.currentCount)
      .replace('[item_max]', this.maxCount);

    this.viewMoreStatus.innerText = viewMoreStatusMessage;
    this.viewMoreStatus.setAttribute('aria-hidden', false);

    // hide content from accessibility tree after announcement
    setTimeout(() => {
      this.viewMoreStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
}

customElements.define('product-grid', ProductGrid);
